module.exports = __webpack_public_path__ + "static/Meetrix teach-f885453bf50b3dfad91d62d13d8b969e.png";